import _ from "lodash";
import { makeAPIClient } from "../../../framework/util";
import * as z from "../../../framework";
import { queryCache, useQuery } from "@msidata/zeact";

export const apiClient = makeAPIClient({
    serviceProApiUrl: window.z.configuration.serviceProApiUrl || ""
});

export enum endpoints {
    getConfig = "Notifications/Configuration",
    coreEnabled = "Notifications/Enabled",
    companyEnabled = "Notifications/CompanyEnabled",
    useCompanyLogo = "Notifications/UseCompanyLogo",
    companyLogoUrl = "Notifications/CompanyLogoUrl",
    updateCompanyLogo = "Notifications/UpdateCompanyLogo",
    footer = "Notifications/Footer"
}

async function fetchConfig() {
    const response = await apiClient.get(endpoints.getConfig);
    return response.data.d.results as NotificationsConfig;
}

export enum queryKeys {
    config = "NotificationsConfig"
}

interface NotificationsConfig {
    CoreEnabled: boolean;
    CompanyEnabled: boolean;
    UseCompanyLogo: boolean;
    CompanyLogoUrl?: string;
    Footer?: string;
}
const queryConfig = {
    suspense: true,
    initialStale: false,
    refetchOnWindowFocus: false
};

const notificationsEnabledKey = "NotificationsEnabled";
export async function areNotificationsEnabled(): Promise<boolean> {
    try {
        let cachedValue = localStorage.getItem(notificationsEnabledKey);
        if (cachedValue) {
            return Promise.resolve(cachedValue.toLowerCase() === "true");
        }
        let enabled = false;
        const config = await queryCache.fetchQuery<NotificationsConfig>([queryKeys.config], fetchConfig, queryConfig);
        if (config) {
            const { CoreEnabled, CompanyEnabled } = config;
            enabled = CoreEnabled && CompanyEnabled;
        }
        localStorage.setItem(notificationsEnabledKey, `${enabled}`);
        return Promise.resolve(enabled);

    } catch (error) {
        z.controls.alert({
            type: "danger",
            header: z.ll("Error"),
            message: error.message
        });
        return Promise.resolve(false);
    }
}

export function useNotificationsConfig() {
    return useQuery([queryKeys.config], fetchConfig, queryConfig);
}
